import {AfterViewInit, Component, Input} from '@angular/core';
import {CircleChartData} from '../../../../../models/chart';
import {GaugeCircleChartData} from '../../../../../models/influencer';
import {marketDrillDownColorIndex} from '../../../../app.constants';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'market-drill-down',
  templateUrl: './market-drill-down.component.html',
  styleUrls: ['./market-drill-down.component.scss']
})
export class MarketDrillDownComponent implements AfterViewInit {
  static COMPONENT_NAME = 'MarketDrillDownComponent';
  @Input()
  public markets: GaugeCircleChartData[];

  constructor(private pdfService: PdfExportService) {

  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(MarketDrillDownComponent.COMPONENT_NAME);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/content/market-drill-down/market-drill-down.component.ts